import chexfinerfoodsLogo from "/img/integration/chexfinerfoods.png"
import { EmailConfigPage } from "../email-config-page"

export function ConfigChexFinerFoodsPage() {
  return (
    <EmailConfigPage
      logo={chexfinerfoodsLogo}
      logoAlt="Chex Finer Foods"
      integrationName="chexfinerfoods"
      displayName="Chex Finer Foods"
      connectPath="/setup/connect/chexfinerfoods"
    />
  )
}
